export default "__VITE_ASSET__6NxdRWtV__"